import { callBackendApiWithoutAuth } from './call';

export interface HashzResponse {
  success: number;
  backendCommitHash: string;
}

// Bit different than the other api functions, in that it doesn't resolve into
// the entire response, just part of it
export const getBackendGitCommitHash = async (abortSignal?: AbortSignal) => {
  const data = (await callBackendApiWithoutAuth({
    method: 'get',
    endpoint: '/hashz',
    abortSignal,
  })) as HashzResponse;

  return data.backendCommitHash;
};
